import { toastRuntimeError } from '@/shared/utils';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { RenameCampaign } from '../api';
import { useInvalidateAllCampaigns } from './use-invalidate-all-campaigns';

interface RenameCampaignMutationRequest {
  campaignId: string;
  campaignName: string;
}

export const useRenameCampaignMutation = () => {
  const invalidateAllCampaigns = useInvalidateAllCampaigns();

  const renameCampaignMutation = useMutation({
    mutationFn: ({ campaignId, campaignName }: RenameCampaignMutationRequest) =>
      RenameCampaign(campaignId, { name: campaignName }),
    onSuccess: async () => {
      await invalidateAllCampaigns();
      toast.success('Campaign name updated.');
    },
    onError: (e) => {
      toastRuntimeError(e, 'Failed to rename campaign. Please try again.');
    },
  });

  return renameCampaignMutation;
};
